import { render, staticRenderFns } from "./SocketReconnectModal.vue?vue&type=template&id=479aa951&scoped=true&"
import script from "./SocketReconnectModal.vue?vue&type=script&lang=js&"
export * from "./SocketReconnectModal.vue?vue&type=script&lang=js&"
import style0 from "./SocketReconnectModal.vue?vue&type=style&index=0&id=479aa951&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479aa951",
  null
  
)

export default component.exports